import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-administrator-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './administrator-menu.component.html',
  styleUrl: './administrator-menu.component.css'
})
export class AdministratorMenuComponent {
  @ViewChild('dt1', { static: false }) dt1: any;
  @ViewChild('dt2', { static: false }) dt2: any;
  userName: any;
  lang: any;
  associatesList: any[] = [];
  companiesList: any[] = [];
  monthDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  dropDowndate: any;
  branchDropdown: any[] = [];
  customerDropdown: any[] = [];
  selectedBranch: string = '-1';
  selectedCustomer: string = '-1';
  selectedService: string = '-1';
  selectedDate: string = '';
  weekEndingDate: string = '';
  displayByCompany: boolean = false;
  timeSheetDate: string = '';

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private as: AdminService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.timesheet');
    if (isPlatformBrowser(this.platformId)) {
      const currentYear = new Date().getFullYear();
      const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');
      this.selectedDate = `01-${currentMonth}-${currentYear}`
      this.getAssociates();
    }
  }

  getAssociates() {
    this.ts.getMonthListV2()
      .subscribe({
        next: (resMonthList: any) => {
          this.monthDropdown = resMonthList.data;
          // console.log(resMonthList.data[0].dayDate);
          const [day, month, year] = resMonthList.data[0].dayDate.split('-');
          let newFormat = `${year}-${month}-${day}`;
          this.dropDowndate = `${day}-${month}-${year}`;
          this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(newFormat));
          // this.getAssociatesList(newFormat);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();   
				    return
          }
        }
      });
    
    this.as.getBranches()
      .subscribe({
        next: (resBranchList: any) => {
          this.branchDropdown = resBranchList.data;
          // console.log(this.branchDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			      return			
          }
        }
      });
    
    this.as.getCustomers()
      .subscribe({
        next: (resCustmomersList: any) => {
          this.customerDropdown = resCustmomersList.data;
          // console.log(this.customerDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
			      return	
          }
        }
      });

  }

  onSearch() {
    // console.log('Branch:', this.selectedBranch);
    // console.log('Customer:', this.selectedCustomer);
    // console.log('Date:', this.selectedDate);
    if (this.selectedDate) {
      this.weekEndingDate = this.getDate(this.selectedDate);
    } else {
      this.weekEndingDate = '';
    }
    // console.log(this.weekEndingDate);
    this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(this.weekEndingDate));

    const filters = {
      weekEndingDate: this.weekEndingDate,
      companyId: this.selectedCustomer,
      departmentId: this.selectedService
    }
    // departmentId: this.selectedBranch
    if (this.selectedCustomer === '-1') {
      // console.log("list company")
      this.displayByCompany = false;
      this.getCompanyList(filters);
    } else {
      // console.log("list Section");
      this.getAssociatesList(filters);
    }
  }

  onCmpSearch(compId: any) {
    this.selectedCustomer = compId;
    this.onSearch();
  }

  clearAll() {
    this.selectedDate = '';
    this.selectedCustomer = '-1';
    this.selectedBranch = '-1';
    this.totalCount = 0;
    this.displayByCompany = false;
    this.associatesList = [];
  }
  // fncCng(event: any) {
  //   let dateFormat = this.getDateFromEvent(event);
  //   this.getAssociatesList(dateFormat);
  // }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getCompanyList(filtersObj: any) {

    // this.as.getCompanyList(filtersObj)
    this.as.getCompanySection(filtersObj)
      .subscribe({
        next: (res: any) => {
          // this.associatesList = this.applyEncryption(res.data);
          if (res.status) {
            // this.companiesList = res.data;
            this.companiesList = res.data.map((row: any) => {
              const nestedSections = row.timesheetSummaryCompanySectionGroupDto
                ?.map((x: any) => x.section)
              .join(' ') || '';
              // const searchTextParts: string[] = [];
              // searchTextParts.push(row.customerName);
              // searchTextParts.push(row.timesheetSummaryCompanySectionGroupDto.section);

              return {
                ...row,
                comSearchText: `${row.customerName} ${nestedSections}`.toLowerCase()
                // comSearchText: searchTextParts.join(' ').toLowerCase(),

              };
            });
            setTimeout(() => this.updateVisibleData(), 0);            
          } else {
            this.companiesList = [];
          }
          // console.log(this.companiesList)
          this.totalCount = this.companiesList.length;
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          }
        }
      });

  }

  getAssociatesList(filtersObj: any) {

    this.as.getAssociatesByCompany(filtersObj)    
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.associatesList = this.applyEncryption(res.data);
  
            this.associatesList = res.data.map((row: any) => {
              const nestedSections = row.timesheetSummary
                ?.map((x: any) => x.section)
                .join(' ') || '';

              return {
                ...row,
                timesheetSummary: row.timesheetSummary?.map((x: any) => ({
                ...x,
                timesheetId: Base64UrlService.encode(this.en.encryptionAES(x.timesheetId.toString())),
                userid: Base64UrlService.encode(this.en.encryptionAES(x.userid.toString())),
                userIdOrg: x.userid
              })),
                searchText: `${row.sectionName} ${nestedSections}`.toLowerCase()
              };
            });
            console.log(this.associatesList);
            this.displayByCompany = true;
            setTimeout(() => this.updateVisibleData(), 0);            
          } else {
            this.associatesList = [];
          }
          this.totalCount = this.associatesList.length;
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          }
        }
      });

  }
  ngAfterViewInit() {
    // 
  }

  applyFilterGlobal($event: Event) {
    // const value = (event.target as HTMLInputElement).value;
    // this.dt2.filterGlobal(value, 'contains');
    const input = $event.target as HTMLInputElement;
    this.dt1.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {   
    if (!this.dt2) {
      this.visibleData = this.associatesList;
      return;
    }
    const filtered = this.dt2.filteredValue ?? this.associatesList;
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  // Compute totals dynamically
  get totalRegular() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.regular;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  
  get totalOverTime() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.overtime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalMn() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.midnightOvertime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get overAllTotal() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.total;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalNotSubmit() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.notSubmit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalSubmit() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.submit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalReject() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.reject;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalApprove() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.approve;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalHome() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.teleWork;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalAbsence() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.absence;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalPh() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.paidHoliday;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }

  get totalResource() {
    if (!this.visibleData || this.visibleData.length === 0) return '0';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.userCount;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h;
        }
      });
    });
    return totalSeconds;
    
  }

  get totalContract() {
    if (!this.visibleData || this.visibleData.length === 0) return '0';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummaryCompanySectionGroupDto) return;

      customer.timesheetSummaryCompanySectionGroupDto.forEach((admin: any) => {
        const timeStr = admin?.contractCount;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += h;
        }
      });
    });
    return totalSeconds;
    
  }

  get totalRegularSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.regular;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }  
  get totalOverTimeSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.overtime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalMnSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.midnightOvertime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get overAllTotalSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.total;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalNotSubmitSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.notSubmit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
    
  }
  get totalSubmitSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.submit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalRejectSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.reject;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalApproveSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.approve;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalHomeSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.teleWork;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalAbsenceSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.absence;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalPhSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.paidHoliday;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }

  formatSeconds(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    // const seconds = totalTime % 60;
    // :${ this.pad(seconds) }
    return `${hours}:${this.pad(minutes)}`;
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
  
  getMonthYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }
  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      elm.timesheetSummary.forEach((obj: any, index: any) => {
        const encryptedId = Base64UrlService.encode(
          this.en.encryptionAES(obj.timesheetId.toString())
        );
        elm.timesheetSummary[index].timesheetId = encryptedId;
      }) 
    });
    return dt;
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  createSingleAll(staffId: string, loginId: string) {
    // let date = this.dropDowndate;
    let date = this.selectedDate;
    // console.log(this.selectedDate);
    // return;
    // let curDateArr = this.dropDowndate.split('-');
    let curDateArr = this.selectedDate.split('-');
    let newDateFormat = `${curDateArr[2]}-${curDateArr[1]}-${curDateArr[0]}`;
      this.ts.downloadTimesheet(newDateFormat, staffId)
        .subscribe({
          next: (res: any) => {
            // Create a blob from the response
            const blob = new Blob([res.body ?? res], { type: 'application/zip' });

            // Create a temporary download link
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;

            // Optional: derive filename from API or generate dynamically
            a.download = 'TS_' + date + '-'+loginId+'.zip';

            // Trigger the download
            a.click();

            // Cleanup
            URL.revokeObjectURL(fileURL);
          },
          error: (err: any) => {
            console.error('Error downloading file:', err);
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }
}
